import React from "react";
import { useNavigate } from "react-router-dom";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./Slider.css";

const Slider = () => {
  const navigate = useNavigate();
  const handleButtonClick = (event) => {
    const sliderUrl = event.currentTarget.dataset.path;
    navigate(sliderUrl);
  };

  return (
    <>
      <Swiper
        navigation={true}
        pagination={{ clickable: true }}
        modules={[Navigation, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide
          id="Slider1"
          style={{
            backgroundImage: `url(/assets/img/banners/Slide-1.jpg)`,
          }}
        >
          <p>The Big 6</p>
          <button
            data-path="/datavis/2009633e-c783-4055-b997-c565a4b1f66c#expanded"
            onClick={handleButtonClick}
          >
            The Most Frequently Featured Authors in African American Review
          </button>
        </SwiperSlide>
        <SwiperSlide
          id="Slider1"
          style={{
            backgroundImage: `url(/assets/img/banners/Slide-2.jpg)`,
          }}
        >
          <p>The Novel Generator</p>
          <button data-path="/novels" onClick={handleButtonClick}>
            Find Your Next Novel to Read
          </button>
        </SwiperSlide>
        <SwiperSlide
          id="Slider1"
          style={{
            backgroundImage: `url(/assets/img/banners/Slide-3.jpg)`,
          }}
        >
          <p>The Spoken Word</p>
          <button data-path="/podcasts" onClick={handleButtonClick}>
            Listen to a Podcast
          </button>
        </SwiperSlide>
        <SwiperSlide
          id="Slider1"
          style={{
            backgroundImage: `url(/assets/img/banners/Slide-4.jpg)`,
          }}
        >
          <p>T'Challa Rising</p>
          <button
            data-path="/datavis/c49ad7b3-e42e-4430-b102-7876d6c1b961#expanded"
            onClick={handleButtonClick}
          >
            Black Panther Prints, Reprints, and Variants
          </button>
        </SwiperSlide>
        <SwiperSlide
          id="Slider1"
          style={{
            backgroundImage: `url(/assets/img/banners/Slide-5.jpg)`,
          }}
        >
          <p>The Sisterhood</p>
          <button
            data-path="/podcasts/4cd6947b-fe39-4b4f-903c-adc2578af7dd"
            onClick={handleButtonClick}
          >
            The story of an inspirational 1977 photo
          </button>
        </SwiperSlide>
      </Swiper>
    </>
  );
};

export default Slider;
